<div class="fs-2 with-close" mat-dialog-title>
    Souhaitez vous enregistrer cette recherche ?
    <i class="fa fa-close" (click)="onNoClick()" aria-hidden="true"></i>
</div>
<div mat-dialog-content>
    <form (ngSubmit)="onYesClick()" [formGroup]="favoriteForm" class="mt-2">
        <mat-form-field>
            <mat-label>Titre de votre recherche</mat-label>
            <input formControlName="title" matInput class="text">
        </mat-form-field>
    </form>
    <p>
        Une recherche enregistrée permet de recevoir en temps réel des alertes mails sur les nouvelles annonces.
    </p>
        <img class="svg_mail-notif" src="https://www.lybox.fr/build/images/svg/mobile-notification.svg" alt="Alerte mail">
</div>
<div mat-dialog-actions>
    <button (click)="onNoClick()" type="reset" class="btn btn-outline">
        Fermer
    </button>
    <button (click)="onYesClick()" type="submit" class="btn btn-primary">
        <mat-spinner diameter="26" *ngIf="loading"></mat-spinner>
        <ng-container *ngIf="!loading">Enregistrer</ng-container>
    </button>
</div>
